<template>
  <b-modal
    ref="suspendUserConfirm"
    centered
    size="md"
    title="Wait! Are you sure?"
    header-text-variant="danger"
    footer-bg-variant=""
    hide-header
    scrollable
    @hidden="unselectUser(), clearSuspensionReason()">

    <b-alert
      variant="light-danger"
      show
      class="mb-8">
      <p class="font-size-lg mb-0">
        When a user shuts down, all accounts on every available server for that user will be blocked, and all of their sessions will be reset as well.
      </p>
    </b-alert>

    <div class="font-weight-bold mb-2">User Details</div>
    <b-list-group
      v-if="selectedUserId !== null"
      class="mb-6">
      <b-list-group-item class="d-flex align-items-center">
        User ID
        <b-badge
          variant="light"
          class="ml-auto font-size-xs">{{ selectedUser.code }}</b-badge>
      </b-list-group-item>
      <b-list-group-item class="d-flex align-items-center">
        Reseller ID
        <span class="ml-auto">{{ selectedUser.item_id }}</span>
      </b-list-group-item>
      <b-list-group-item class="d-flex align-items-center">
        Devices
        <span class="ml-auto">{{ selectedUser.devices }}</span>
      </b-list-group-item>
      <b-list-group-item class="d-flex align-items-center">
        Created
        <span class="ml-auto">{{ selectedUser.created | moment("DD.MM.YYYY, HH:mm") }}</span>
      </b-list-group-item>
      <b-list-group-item class="d-flex align-items-center">
        Expiry
        <span class="ml-auto">{{ selectedUser.expiry | moment("DD.MM.YYYY, HH:mm") }}</span>
      </b-list-group-item>
    </b-list-group>

    <b-form-group
      id="reason"
      label="Suspension reason (optional)"
      label-for="reason"
      class="w-100 mb-0">
      <b-form-textarea
        id="reason-textarea"
        name="reason-textarea"
        v-model="suspensionReason"
        rows="4"
        no-resize
        style="min-height: 100px;" />
    </b-form-group>

    <template #modal-footer>
      <div class="d-flex w-100">
        <b-button
          variant="outline-secondary"
          size="md"
          @click="hideModal('suspendUserConfirm')">
          Cancel
        </b-button>
        <b-button
          variant="danger"
          size="md"
          class="ml-auto"
          :disabled="usersResponses('switchUser')"
          @click="switchUser(), hideModal('suspendUserConfirm')">
          Yes, suspend this user
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { SWITCH_USER, UNSELECT_USER } from '@/core/services/store/users.module'
import { mapGetters } from 'vuex'
import { eventBus } from '@/main'
import { showModal, hideModal } from '@/core/utils'
import moment from 'moment'

export default {
  name: 'ModalSuspendUser',
  data() {
    return {
      suspensionReason: '',
      
      showModal,
      hideModal,
      moment,
    }
  },
  computed: {
    ...mapGetters([
      'selectedUser',
      'selectedUserId',
      'usersResponses',
    ]),
  },
  mounted() {
    eventBus.$on('openModal', type => { this.showModal(type) })
  },
  destroyed() {
    eventBus.$off('openModal')
  },
  methods: {
    unselectUser() {
      this.$store.commit(UNSELECT_USER)
    },

    switchUser() {
      this.$store.dispatch(SWITCH_USER, {
        id: this.selectedUserId,
        memo: this.suspensionReason,
      })
    },

    clearSuspensionReason() {
      this.suspensionReason = ''
    },
  }
}
</script>
